import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { MERCURY_LAYER } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledWellConnector = styled.span.withConfig({
  displayName: "WellConnector__StyledWellConnector"
})(() => {
  return {
    position: 'absolute',
    top: '50%',
    right: '0',
    transform: 'translateY(-50%) translateX(50%)',
    zIndex: MERCURY_LAYER
  };
});
export const WellConnector = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps
  } = filterProps(Object.assign({}, rest));
  return /*#__PURE__*/_jsx(StyledWellConnector, Object.assign({}, domProps, {
    children: children
  }));
};